<template>
  <div class="calculatePage" ref="calculatePage">
    <!-- 算力市场 -->
    <div class="nav_box">
      <Nav :isClass="isClass" :active="2"></Nav>
    </div>
    <div class="banner">
      <div class="banner_title">汇聚全国算力资源</div>
      <div class="banner_new">HPC、AI、Cloud等多元算力产品，由算力科技统一提供交付服务与技术支持</div>
    </div>
    <div class="content_box">
      <div class="bg">
        <div class="inner_box">
          <el-input placeholder="请输入内容" v-model="searchValue" class="input-with-select">
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
          <div class="tab_box">
            <div class="tab_item" :class="{ act: index == tabAct }" v-for="(item, index) in tabList" :key="index"
              @click="tabChange(index)">
              {{ item.title }}
            </div>
          </div>
          <div class="list_box" v-if="list.length > 0">
            <div class="list_item" v-for="(item, index) in list" :key="index">
              <div class="lable">{{ item.type }}</div>
              <div class="item_content">
                <div class="item_content_top">
                  <!-- <img src="../assets/img/位图 3@2x.png"> -->
                  <div class="img"><img v-if="item.url" :src="item.url"></div>
                  <div class="item_title">{{ item.title }}</div>
                </div>
                <el-descriptions class="margin-top" :column="3">
                  <el-descriptions-item label="物理区域" label-class-name="my-label" content-class-name="my-content">{{
                    item.area }}</el-descriptions-item>
                  <el-descriptions-item label="产品类型">{{ item.type }}</el-descriptions-item>
                  <el-descriptions-item label="计费模式">{{ item.time }}</el-descriptions-item>
                </el-descriptions>
                <div class="specifications">
                  <div class="specifications_title">技术规格：</div>
                  <div class="specifications_item">
                    <div v-for="(item2, index2) in item.childList" :key="index2">{{ item2 }}</div>
                  </div>
                </div>
              </div>
              <div class="item_footer">
                <div class="price">
                  <span class="new_price">{{ item.pre }}</span>
                  <span class="new_price_unit">/{{ item.t == 0 ? '卡时' : item.t == 1 ? '核时' : item.t == 2 ? '台/月' : '卡时'
                    }}</span>
                  <span class="scribe">{{ item.pre }}/{{ item.t == 0 ? '卡时' : item.t == 1 ? '核时' : item.t == 2 ? '台/月' :
                    '卡时'
                    }}</span>
                </div>
                <div class="btn">
                  <span class="link">立即咨询</span>
                  <div class="submit">立即购买</div>
                </div>
              </div>
            </div>
          </div>
          <div class="empty" v-if="list.length == 0">
            <div class="empty_title">暂无结果</div>
          </div>
        </div>
      </div>
    </div>
    <div class="section6">
      <div class="fort_box">
        <div class="foot_title">共建科技算力服务生态</div>
        <div class="foot_btn">立即咨询</div>
      </div>
    </div>
    <!-- <div class="footer_fout">
      <Clas></Clas>
    </div> -->
  </div>
</template>

<script>
import Nav from "../components/nav.vue";
export default {
  components: {
    Nav
  },
  data() {
    return {
      isClass: false,
      searchValue: '',
      tabAct: 0,
      tabList: [{
        title: '全部'
      }, {
        title: 'GPU容器云'
      }, {
        title: 'HPC'
      }, {
        title: '裸金属'
      }, {
        title: '云主机'
      }, {
        title: '存储'
      }],
      list: [{
        childList: ['GPU：NVIDIA Tesla H100 SXM（显存：80G）'],
        title: 'N-H100-80',
        area: '金华',
        type: 'GPU容器云',
        pre: '25元',
        time: '卡时'
      }, {
        childList: ['GPU：NVIDIA Tesla H100 SXM（显存：80G）'],
        title: 'N-H800-80',
        area: '金华',
        type: 'GPU容器云',
        pre: '25元',
        time: '卡时'
      }, {
        childList: ['GPU：NVIDIA Tesla H100 SXM（显存：80G）', 'CPU：Intel 6430 CPU 2.1GHz'],
        title: 'N-4090-24',
        area: '金华',
        type: 'GPU容器云',
        pre: '3元',
        time: '卡时'
      }, {
        childList: ['GPU：HUAWEI Ascend 910B PCIE（显存：60G）', 'CPU：Kunpeng 920 2.6GHz'],
        title: 'H-910B-64',
        area: '金华',
        type: 'GPU容器云',
        pre: '15元',
        time: '卡时'
      }, {
        childList: ['GPU：8*Z100L 32G', 'CPU：2*CPU-Hygon 7390 2.7G', '内存：768G', '硬盘：6.4T'],
        title: '高性能计算GPU-Z100L(TYY-HPC-Z100L)',
        area: '金华',
        type: 'HPC',
        pre: '3.5元',
        time: '卡时',
        url: require('../assets/img/形状@2x.png'),
      }, {
        childList: ['GPU：8*K100 64G PCIE', 'CPU：2*CPU-Hygon 7390 2.7G', '内存：768GB DDR4', '硬盘：6.4TB'],
        title: '高性能计算GPU-K100（SLHL-HPC-GPU-K100）',
        area: '金华',
        type: 'HPC',
        pre: '3.5元',
        time: '卡时',
        url: require('../assets/img/形状@2x.png'),
      }, {
        childList: ['CPU：2*CPU-Hygon 7390 2.7G', '内存：768GB DDR4', '硬盘：6.4TB'],
        title: '高性能计算CPU（SLHL-HPC-Hygon7390-768）',
        area: '金华',
        type: 'HPC',
        pre: '0.08元',
        time: '元/核时',
        url: require('../assets/img/形状@2x.png'),
        t: 1
      }, {
        childList: ['GPU：H100 80G*8 NVLINK', 'CPU：Intel(R) Xeon(R) Platinum 8468 (48核,2.1GHz,105MB) 350W*2', '内存：64G DDR5 4400MHz*32', '硬盘：1.92T SSD*2;3.84T NVME SSD*3', '网络：ConnectX4LX 25G*2， ConnectX6 200G*1，ConnectX7 400G*8'],
        title: '裸金属H100-80',
        area: '金华',
        type: '裸金属',
        pre: '114,000元',
        time: '台/月',
        t: 2,
        url: require('../assets/img/矩形@2x (4).png'),
      }, {
        childList: ['GPU：H800 80G*8 NVLINK', 'CPU：Intel(R) Xeon(R) Platinum 8480+ (56核,2GHz,105MB) 350W*2', '内存：64G DDR5 4400MHz*32', '硬盘：3.84T NVME SSD*8', '网络：ConnectX4LX 25G*2， ConnectX6 100G*2，ConnectX7 400G*4'],
        title: '裸金属H800-80',
        area: '金华',
        type: '裸金属',
        pre: '114,000元',
        time: '台/月',
        t: 2,
        url: require('../assets/img/矩形@2x (4).png'),
      }, {
        childList: ['GPU：RTX4090 24G*8', 'CPU：Intel(R) Xeon(R) Gold 6430 (32核,2.1GHz)*2 ', '内存：32G DDR5 4800MHz*16', '硬盘：480G SATA SSD*2 + 3.84T SATA SSD*2', '网络：NIC-BCM957412-F-B-10Gb-2P*1,NIC-GE-4P-360T-B2-1-X*1'],
        title: '裸金属RTX4090',
        area: '金华',
        type: '裸金属',
        pre: '17,280元',
        time: '台/月',
        t: 2,
        url: require('../assets/img/矩形@2x (4).png'),
      }, {
        childList: ['GPU：Ascend 910B*8', 'CPU：HUAWEI Kunpeng 920 5250 (48核,2.6GHz)*4 ', '内存：32G DDR4 3200MHz*16', '硬盘：480GB-SATA6Gb/s*2 + NVMe固态硬盘-7680GB-Gen4*2', '网络：TM280*1,TM210*1,FLEX IO*4,MCX623106AN-CDAT*1'],
        title: '裸金属华为昇腾910B AI加速卡',
        area: '金华',
        type: '裸金属',
        pre: '86,400元',
        time: '台/月',
        t: 2,
        url: require('../assets/img/矩形@2x (4).png'),
      }]
    }
  },
  // 监听页面滚动
  mounted() {
    window.scrollTo(0, 0)
    let minWidth = window.screen.width;
    this.$refs["calculatePage"].style.minWidth = minWidth + "px";
    window.addEventListener('scroll', this.mouseWheelHandle, true);
  },
  methods: {
    mouseWheelHandle() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 400) {
        this.isClass = true
      } else {
        this.isClass = false
      }
    },
    tabChange(index) {
      this.tabAct = index
      if (index == 0) {
        this.list = [{
          childList: ['GPU：NVIDIA Tesla H100 SXM（显存：80G）'],
          title: 'N-H100-80',
          area: '金华',
          type: 'GPU容器云',
          pre: '25元',
          time: '卡时'
        }, {
          childList: ['GPU：NVIDIA Tesla H100 SXM（显存：80G）'],
          title: 'N-H800-80',
          area: '金华',
          type: 'GPU容器云',
          pre: '25元',
          time: '卡时'
        }, {
          childList: ['GPU：NVIDIA Tesla H100 SXM（显存：80G）', 'CPU：Intel 6430 CPU 2.1GHz'],
          title: 'N-4090-24',
          area: '金华',
          type: 'GPU容器云',
          pre: '3元',
          time: '卡时'
        }, {
          childList: ['GPU：HUAWEI Ascend 910B PCIE（显存：60G）', 'CPU：Kunpeng 920 2.6GHz'],
          title: 'H-910B-64',
          area: '金华',
          type: 'GPU容器云',
          pre: '15元',
          time: '卡时'
        }, {
          childList: ['GPU：8*Z100L 32G', 'CPU：2*CPU-Hygon 7390 2.7G', '内存：768G', '硬盘：6.4T'],
          title: '高性能计算GPU-Z100L(TYY-HPC-Z100L)',
          area: '金华',
          type: 'HPC',
          pre: '3.5元',
          time: '卡时',
          url: require('../assets/img/形状@2x.png'),
        }, {
          childList: ['GPU：8*K100 64G PCIE', 'CPU：2*CPU-Hygon 7390 2.7G', '内存：768GB DDR4', '硬盘：6.4TB'],
          title: '高性能计算GPU-K100（SLHL-HPC-GPU-K100）',
          area: '金华',
          type: 'HPC',
          pre: '3.5元',
          time: '卡时',
          url: require('../assets/img/形状@2x.png'),
        }, {
          childList: ['CPU：2*CPU-Hygon 7390 2.7G', '内存：768GB DDR4', '硬盘：6.4TB'],
          title: '高性能计算CPU（SLHL-HPC-Hygon7390-768）',
          area: '金华',
          type: 'HPC',
          pre: '0.08元',
          time: '元/核时',
          url: require('../assets/img/形状@2x.png'),
          t: 1
        }, {
          childList: ['GPU：H100 80G*8 NVLINK', 'CPU：Intel(R) Xeon(R) Platinum 8468 (48核,2.1GHz,105MB) 350W*2', '内存：64G DDR5 4400MHz*32', '硬盘：1.92T SSD*2;3.84T NVME SSD*3', '网络：ConnectX4LX 25G*2， ConnectX6 200G*1，ConnectX7 400G*8'],
          title: '裸金属H100-80',
          area: '金华',
          type: '裸金属',
          pre: '114,000元',
          time: '台/月',
          t: 2,
          url: require('../assets/img/矩形@2x (4).png'),
        }, {
          childList: ['GPU：H800 80G*8 NVLINK', 'CPU：Intel(R) Xeon(R) Platinum 8480+ (56核,2GHz,105MB) 350W*2', '内存：64G DDR5 4400MHz*32', '硬盘：3.84T NVME SSD*8', '网络：ConnectX4LX 25G*2， ConnectX6 100G*2，ConnectX7 400G*4'],
          title: '裸金属H800-80',
          area: '金华',
          type: '裸金属',
          pre: '114,000元',
          time: '台/月',
          t: 2,
          url: require('../assets/img/矩形@2x (4).png'),
        }, {
          childList: ['GPU：RTX4090 24G*8', 'CPU：Intel(R) Xeon(R) Gold 6430 (32核,2.1GHz)*2 ', '内存：32G DDR5 4800MHz*16', '硬盘：480G SATA SSD*2 + 3.84T SATA SSD*2', '网络：NIC-BCM957412-F-B-10Gb-2P*1,NIC-GE-4P-360T-B2-1-X*1'],
          title: '裸金属RTX4090',
          area: '金华',
          type: '裸金属',
          pre: '17,280元',
          time: '台/月',
          t: 2,
          url: require('../assets/img/矩形@2x (4).png'),
        }, {
          childList: ['GPU：Ascend 910B*8', 'CPU：HUAWEI Kunpeng 920 5250 (48核,2.6GHz)*4 ', '内存：32G DDR4 3200MHz*16', '硬盘：480GB-SATA6Gb/s*2 + NVMe固态硬盘-7680GB-Gen4*2', '网络：TM280*1,TM210*1,FLEX IO*4,MCX623106AN-CDAT*1'],
          title: '裸金属华为昇腾910B AI加速卡',
          area: '金华',
          type: '裸金属',
          pre: '86,400元',
          time: '台/月',
          t: 2,
          url: require('../assets/img/矩形@2x (4).png'),
        }]
      } else if (index == 1) {
        this.list = [
          {
            childList: ['GPU：NVIDIA Tesla H100 SXM（显存：80G）'],
            title: 'N-H100-80',
            area: '金华',
            type: 'GPU容器云',
            pre: '25元',
            time: '卡时'
          }, {
            childList: ['GPU：NVIDIA Tesla H100 SXM（显存：80G）'],
            title: 'N-H800-80',
            area: '金华',
            type: 'GPU容器云',
            pre: '25元',
            time: '卡时'
          }, {
            childList: ['GPU：NVIDIA Tesla H100 SXM（显存：80G）', 'CPU：Intel 6430 CPU 2.1GHz'],
            title: 'N-4090-24',
            area: '金华',
            type: 'GPU容器云',
            pre: '3元',
            time: '卡时'
          }, {
            childList: ['GPU：HUAWEI Ascend 910B PCIE（显存：60G）', 'CPU：Kunpeng 920 2.6GHz'],
            title: 'H-910B-64',
            area: '金华',
            type: 'GPU容器云',
            pre: '15元',
            time: '卡时'
          }
        ]
      } else if (index == 2) {
        this.list = [{
          childList: ['GPU：8*Z100L 32G', 'CPU：2*CPU-Hygon 7390 2.7G', '内存：768G', '硬盘：6.4T'],
          title: '高性能计算GPU-Z100L(TYY-HPC-Z100L)',
          area: '金华',
          type: 'HPC',
          pre: '3.5元',
          time: '卡时',
          url: require('../assets/img/形状@2x.png'),
        }, {
          childList: ['GPU：8*K100 64G PCIE', 'CPU：2*CPU-Hygon 7390 2.7G', '内存：768GB DDR4', '硬盘：6.4TB'],
          title: '高性能计算GPU-K100（SLHL-HPC-GPU-K100）',
          area: '金华',
          type: 'HPC',
          pre: '3.5元',
          time: '卡时',
          url: require('../assets/img/形状@2x.png'),
        }, {
          childList: ['CPU：2*CPU-Hygon 7390 2.7G', '内存：768GB DDR4', '硬盘：6.4TB'],
          title: '高性能计算CPU（SLHL-HPC-Hygon7390-768）',
          area: '金华',
          type: 'HPC',
          pre: '0.08元',
          time: '元/核时',
          url: require('../assets/img/形状@2x.png'),
          t: 1
        }]
      } else if (index == 3) {
        this.list = [{
          childList: ['GPU：H100 80G*8 NVLINK', 'CPU：Intel(R) Xeon(R) Platinum 8468 (48核,2.1GHz,105MB) 350W*2', '内存：64G DDR5 4400MHz*32', '硬盘：1.92T SSD*2;3.84T NVME SSD*3', '网络：ConnectX4LX 25G*2， ConnectX6 200G*1，ConnectX7 400G*8'],
          title: '裸金属H100-80',
          area: '金华',
          type: '裸金属',
          pre: '114,000元',
          time: '台/月',
          t: 2,
          url: require('../assets/img/矩形@2x (4).png'),
        }, {
          childList: ['GPU：H800 80G*8 NVLINK', 'CPU：Intel(R) Xeon(R) Platinum 8480+ (56核,2GHz,105MB) 350W*2', '内存：64G DDR5 4400MHz*32', '硬盘：3.84T NVME SSD*8', '网络：ConnectX4LX 25G*2， ConnectX6 100G*2，ConnectX7 400G*4'],
          title: '裸金属H800-80',
          area: '金华',
          type: '裸金属',
          pre: '114,000元',
          time: '台/月',
          t: 2,
          url: require('../assets/img/矩形@2x (4).png'),
        }, {
          childList: ['GPU：RTX4090 24G*8', 'CPU：Intel(R) Xeon(R) Gold 6430 (32核,2.1GHz)*2 ', '内存：32G DDR5 4800MHz*16', '硬盘：480G SATA SSD*2 + 3.84T SATA SSD*2', '网络：NIC-BCM957412-F-B-10Gb-2P*1,NIC-GE-4P-360T-B2-1-X*1'],
          title: '裸金属RTX4090',
          area: '金华',
          type: '裸金属',
          pre: '17,280元',
          time: '台/月',
          t: 2,
          url: require('../assets/img/矩形@2x (4).png'),
        }, {
          childList: ['GPU：Ascend 910B*8', 'CPU：HUAWEI Kunpeng 920 5250 (48核,2.6GHz)*4 ', '内存：32G DDR4 3200MHz*16', '硬盘：480GB-SATA6Gb/s*2 + NVMe固态硬盘-7680GB-Gen4*2', '网络：TM280*1,TM210*1,FLEX IO*4,MCX623106AN-CDAT*1'],
          title: '裸金属华为昇腾910B AI加速卡',
          area: '金华',
          type: '裸金属',
          pre: '86,400元',
          time: '台/月',
          t: 2,
          url: require('../assets/img/矩形@2x (4).png'),
        }]
      } else {
        this.list = []
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.mouseWheelHandle);
  },
}
</script>

<style lang="scss" scoped>
.calculatePage {
  position: relative;
  overflow: auto;
}

.nav_box {
  position: fixed;
  // position: sticky;
  top: 0;
  z-index: 99;
  width: 100%;
}

.banner {
  width: 100%;
  height: 700px;
  background-image: url("../assets/img/位图@2x (15).png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .banner_title {
    text-align: center;
    font-weight: 500;
    font-size: 28px;
    color: #FFFFFF;
    margin-bottom: 20px;
  }

  .banner_new {
    text-align: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
  }
}

.content_box {
  background-color: #EBEEF0;

  .bg {
    padding: 50px 0;
    background-image: url("../assets/img/bg2_left.png");
    background-repeat: no-repeat;
    background-size: 576px 458px;
    background-position: left top;
  }

  .inner_box {
    width: 1200px;
    margin: 0 auto;

    .input-with-select {
      height: 50px;
    }

    .tab_box {
      margin: 30px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;

      .tab_item {
        width: 16%;
        height: 35px;
        background-color: #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        // margin: 0 5px;
        cursor: pointer;

        &.act {
          background: #094990;
          color: #FFFFFF;
        }
      }
    }

    .list_box {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;

      .list_item {
        width: 49%;
        background-color: #FFFFFF;
        position: relative;
        overflow: hidden;
        margin-bottom: 20px;

        .lable {
          position: absolute;
          background: #094990;
          font-size: 12px;
          height: 25px;
          color: #fff;
          width: 120px;
          text-align: center;
          line-height: 25px;
          left: -25px;
          top: 20px;
          z-index: 10;
          transform: rotate(-45deg)
        }

        .item_content {
          border-bottom: 1px solid #eee;
          padding: 50px 32px;

          .item_content_top {
            display: flex;
            align-items: center;

            .img {
              width: 50px;
              height: 50px;
              margin-right: 10px;
            }

            img {
              width: 100%;
              height: 100%;
            }
          }



          .specifications {
            display: flex;

            .specifications_title {
              width: 60px;
              height: 17px;
              font-size: 12px;
              color: #333333;


            }

            .specifications_item {
              div {
                font-family: AlibabaPuHuiTiR;
                font-size: 12px;
                color: #333333;
              }
            }

          }
        }

        .item_footer {
          padding: 16px 32px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .price {
            display: flex;
            align-items: center;

            .new_price {
              font-size: 18px;
              color: #094990;
            }

            .new_price_unit {
              font-size: 12px;
              color: #094990;
              margin: 0 10px 0 4px;
            }

            .scribe {
              font-size: 12px;
              color: #999999;
              text-decoration-line: line-through;
            }
          }

          .btn {
            display: flex;
            align-items: center;

            .link {
              font-size: 12px;
              color: #094990;
              margin-right: 10px;
            }

            .submit {
              padding: 7px 15px;
              background: #094990;
              border-radius: 3px;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 48px;
              font-size: 12px;
              color: #FFFFFF;
              cursor: pointer;

              &:hover {
                opacity: .8;
              }
            }
          }
        }
      }
    }
    .empty{
      text-align: center;
      height: 500px;
    }
  }
}

.section6 {
  background-image: url("../assets/img/位图@2x(15).png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 193px;

  .fort_box {
    width: 1300px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .foot_title {
    font-weight: 500;
    font-size: 22px;
    color: #FFFFFF;
  }

  .foot_btn {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 124px;
    height: 40px;
    background: #FFFFFF;
    border-radius: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #094990;

    &:hover {
      background-color: #094990;
      color: #FFFFFF;
    }
  }

}

.footer_fout {
  position: fixed;
  bottom: 10%;
  right: 0;
}

::v-deep .el-descriptions-item__label:not(.is-bordered-label) {
  font-size: 12px;
  color: #333333;
}

::v-deep .el-descriptions-item__container .el-descriptions-item__content {
  font-family: AlibabaPuHuiTiR;
  font-size: 12px;
  color: #333333;
}

::v-deep .el-input-group--append .el-input__inner,
.el-input-group__prepend {
  height: 50px !important;
}
</style>